import { TDeviceName, TPlatform } from '../types'
import { getUserAgent } from './getUserAgent'

export const getDeviceName = (platform: TPlatform): TDeviceName => {
  const userAgent = getUserAgent()
  if (platform === 'tv_xboxone') {
    return 'Xbox'
  } else if (platform === 'tv_samsung') {
    return 'Samsung TV'
  } else if (platform === 'hbbtv') {
    return 'Comcast STB'
  } else if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS Device'
  } else if (/Macintosh|Mac OS X/.test(userAgent)) {
    return 'Mac'
  } else if (/Windows/.test(userAgent)) {
    return 'Windows PC'
  } else if (/Android/.test(userAgent)) {
    return 'Android Device'
  } else {
    return 'Unknown Device'
  }
}
